module.exports = __webpack_public_path__ + "img/info_icon.b8ceb202.svg";